import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "post d-flex flex-column-fluid",
  id: "kt_post"
}
const _hoisted_2 = { class: "row justify-content-end align-items-center mb-8" }
const _hoisted_3 = { class: "col-sm-6" }
const _hoisted_4 = { class: "fs-1 fw-bold mb-0" }
const _hoisted_5 = { class: "col-sm-6 d-flex justify-content-end" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "isax-trash text-white fs-5" }, null, -1)
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "isax-edit-2 text-white fs-5" }, null, -1)
const _hoisted_10 = { class: "d-flex flex-column" }
const _hoisted_11 = { class: "card card-flush mb-10" }
const _hoisted_12 = { class: "card-body" }
const _hoisted_13 = { class: "mb-8" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "fs-5 fw-bold" }, "Tipo de rol", -1)
const _hoisted_15 = { class: "fs-base text-gray-700" }
const _hoisted_16 = { class: "mb-8" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", { class: "fs-5 fw-bold" }, "Descripción", -1)
const _hoisted_18 = {
  key: 0,
  class: "fs-base text-gray-700"
}
const _hoisted_19 = { key: 1 }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", { class: "fs-5 fw-bold" }, "Permisos del rol", -1)
const _hoisted_21 = { class: "row" }
const _hoisted_22 = { class: "d-flex align-items-center py-2 fs-sm" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot h-8px w-8px bg-primary me-1" }, null, -1)
const _hoisted_24 = { class: "flex-lg-row-fluid" }
const _hoisted_25 = { class: "w-50 mb-8" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("h1", { class: "fs-1 fw-bold mb-2" }, "Usuarios asignados", -1)
const _hoisted_27 = {
  key: 0,
  class: "input-group input-group-lg"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("input", {
  type: "text",
  class: "form-control fs-base",
  placeholder: "Buscar usuario"
}, null, -1)
const _hoisted_29 = { class: "input-group-text" }
const _hoisted_30 = { class: "card card-flush mb-6 mb-xl-9" }
const _hoisted_31 = {
  key: 0,
  class: "card-body"
}
const _hoisted_32 = { class: "d-flex align-items-center" }
const _hoisted_33 = { class: "symbol symbol-circle symbol-30px overflow-hidden me-3" }
const _hoisted_34 = { class: "symbol-label text-uppercase fs-xs bg-gray-lighten" }
const _hoisted_35 = {
  key: 1,
  class: "card-body"
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("p", { class: "fs-5" }, "Este rol no tiene usuarios asignados", -1)
const _hoisted_37 = [
  _hoisted_36
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_KTDatatable = _resolveComponent("KTDatatable")!
  const _component_ModalRoleForm = _resolveComponent("ModalRoleForm")!
  const _component_ModalRoleDeleteConfirm = _resolveComponent("ModalRoleDeleteConfirm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roleData, (role) => {
      return (_openBlock(), _createElementBlock("div", {
        id: "kt_content_container",
        class: "container-xxl",
        key: role.id
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h1", _hoisted_4, _toDisplayString(role.name_rol), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            (_ctx.$can('Eliminar rol') && role.active_edit > 0)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "btn btn-secondary btn-active-light-secondary fs-base my-1 me-3",
                  "data-bs-toggle": "modal",
                  "data-bs-target": "#role_delete_confirm",
                  onClick: ($event: any) => (_ctx.deleteRole(role.name_rol))
                }, [
                  _hoisted_7,
                  _createTextVNode(" Eliminar rol ")
                ], 8, _hoisted_6))
              : _createCommentVNode("", true),
            (_ctx.$can('Editar rol') && role.active_edit > 0)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  type: "button",
                  class: "btn btn-primary btn-active-light fs-base my-1",
                  "data-bs-toggle": "modal",
                  "data-bs-target": "#kt_modal_add_role",
                  onClick: ($event: any) => (_ctx.editRole(role))
                }, [
                  _hoisted_9,
                  _createTextVNode(" Editar ")
                ], 8, _hoisted_8))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createElementVNode("span", _hoisted_15, _toDisplayString(role.name_role_condition), 1)
              ]),
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                (role.description_rol)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(role.description_rol), 1))
                  : (_openBlock(), _createElementBlock("p", _hoisted_19, "Sin descripción"))
              ]),
              _createElementVNode("div", null, [
                _hoisted_20,
                _createElementVNode("div", _hoisted_21, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(role.role_list_access, (access) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: access.idAccess,
                      class: "col-sm-6 col-md-3 text-gray-700 fs-5 mb-5"
                    }, [
                      _createElementVNode("div", _hoisted_22, [
                        _hoisted_23,
                        _createTextVNode(_toDisplayString(access.name_access), 1)
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _hoisted_26,
              false
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    _hoisted_28,
                    _createElementVNode("span", _hoisted_29, [
                      _createVNode(_component_inline_svg, { src: "media/icons/iconsax/search-normal.svg" })
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_30, [
              (role.role_list_users.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                    _createVNode(_component_KTDatatable, {
                      loading: _ctx.loading,
                      "table-header": _ctx.tableHeader,
                      "table-data": role.role_list_users,
                      "enable-items-per-page-dropdown": false,
                      class: _normalizeClass('text-white')
                    }, {
                      "cell-name": _withCtx(({ row: data }) => [
                        _createElementVNode("div", _hoisted_32, [
                          _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("div", _hoisted_34, _toDisplayString(data.name_user.charAt(0)) + " " + _toDisplayString(data.last_name_user.charAt(0)), 1)
                          ]),
                          _createTextVNode(" " + _toDisplayString(data.name_user) + " " + _toDisplayString(data.last_name_user), 1)
                        ])
                      ]),
                      "cell-email": _withCtx(({ row: data }) => [
                        _createTextVNode(_toDisplayString(data.email_user), 1)
                      ]),
                      "cell-createdAt": _withCtx(({ row: data }) => [
                        _createTextVNode(_toDisplayString(data.created_at_user), 1)
                      ]),
                      _: 2
                    }, 1032, ["loading", "table-header", "table-data"])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_35, _hoisted_37))
            ])
          ])
        ])
      ]))
    }), 128)),
    _createVNode(_component_ModalRoleForm, {
      onSendDetailData: _cache[0] || (_cache[0] = ($event: any) => (_ctx.getRoleData($event))),
      roleToEdit: _ctx.roleEdit,
      typeForm: _ctx.typeForm
    }, null, 8, ["roleToEdit", "typeForm"]),
    _createVNode(_component_ModalRoleDeleteConfirm, {
      id: _ctx.idRole,
      name: _ctx.roleName
    }, null, 8, ["id", "name"])
  ]))
}